import React from "react"

export const RequestAdminNote = ({ className = "" }) => (
  <div className={`c-modal-note c-modal-note--request-admin ${className}`}>
    <i className="fa fa-info-circle mr-2" />
    {`Note: You are currently in ‘Admin Only Request Mode’, enabling you as an Administrator to create and view sensitive Requests that are only visible when this mode is turned on.  Untick the checkbox below if you would like this Request to still be visible when Admin Only Request Mode is turned off.`}
  </div>
)
